import styled, { css } from 'styled-components';
var solvedStyles = css(["border-radius:18px;margin-left:3px;background-color:", ";color:", ";transition:background-color 0.25s ease;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.positive;
}, function (_ref2) {
  var solved = _ref2.solved;
  return solved ? '#fff' : 'currentColor';
});
export var Count = styled.div.withConfig({
  displayName: "Count",
  componentId: "sc-1c7w1yg-0"
})(["min-width:21px;height:21px;padding:0 6px;border-radius:21px;margin-right:3px;background-color:", ";font-weight:600;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:21px;text-align:center;", ";"], function (_ref3) {
  var theme = _ref3.theme,
    solved = _ref3.solved;
  return solved ? theme.colors.positive : theme.colors.uiL;
}, function (_ref4) {
  var solved = _ref4.solved;
  return solved && solvedStyles;
});